import { useMenu } from 'src/contexts/menu-context'
import type { ListMenuProps } from '../../../global-navigation'
import { hasNextLevel, trackMenuPath } from '../../../utils'
import { LinkItem } from './LinkItem'
import { ParentItem } from './ParentItem'

export const ListMenu = ({ menu, type }: ListMenuProps) => {
  const { state } = useMenu()

  const handleTrack = () => {
    trackMenuPath(
      { ...state, selectedLevel: state.selectedLevel - 1 },
      menu.title
    )
  }

  return (
    <div className="px-6 py-4 mb-3">
      <div className="px-3 py-1.5 space-y-1">
        <p
          style={{ color: menu?.titleColor ? menu.titleColor : '#0A0A0A' }}
          className="font-bold tracking-[0.08px] text-base"
        >
          {menu?.title}
        </p>
        {menu?.showAll && (
          <a
            href={menu.titleURL ? menu.titleURL : undefined}
            onClick={handleTrack}
            className="text-xs font-semibold underline tracking-[0.048px] text-[#232323]"
          >
            Vedi tutti
          </a>
        )}
      </div>
      <div className="px-3 pt-6">
        <p className="text-[10px] tracking-[-0.3px] font-bold text-[#0A0A0A] pb-1">
          Categorie
        </p>
        {menu?.items?.map((el, index: number) =>
          hasNextLevel(el) ? (
            <ParentItem
              item={el}
              type={type}
              position={index}
              key={`parent-item-${index}`}
            />
          ) : (
            <LinkItem item={el} key={`link-item-${index}`} />
          )
        )}
      </div>
    </div>
  )
}
